"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20PresetMinterPauserFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var Erc20PresetMinterPauserFactory = /** @class */ (function (_super) {
    __extends(Erc20PresetMinterPauserFactory, _super);
    function Erc20PresetMinterPauserFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    Erc20PresetMinterPauserFactory.prototype.deploy = function (name, symbol, overrides) {
        return _super.prototype.deploy.call(this, name, symbol, overrides || {});
    };
    Erc20PresetMinterPauserFactory.prototype.getDeployTransaction = function (name, symbol, overrides) {
        return _super.prototype.getDeployTransaction.call(this, name, symbol, overrides || {});
    };
    Erc20PresetMinterPauserFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Erc20PresetMinterPauserFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Erc20PresetMinterPauserFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return Erc20PresetMinterPauserFactory;
}(contracts_1.ContractFactory));
exports.Erc20PresetMinterPauserFactory = Erc20PresetMinterPauserFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'string',
                name: 'name',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'Paused',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'previousAdminRole',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'newAdminRole',
                type: 'bytes32',
            },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'RoleGranted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'RoleRevoked',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'Unpaused',
        type: 'event',
    },
    {
        inputs: [],
        name: 'DEFAULT_ADMIN_ROLE',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'MINTER_ROLE',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'PAUSER_ROLE',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
        ],
        name: 'allowance',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'burn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'burnFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'decimals',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'subtractedValue',
                type: 'uint256',
            },
        ],
        name: 'decreaseAllowance',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
        ],
        name: 'getRoleAdmin',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'getRoleMember',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
        ],
        name: 'getRoleMemberCount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'hasRole',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'addedValue',
                type: 'uint256',
            },
        ],
        name: 'increaseAllowance',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'mint',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pause',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'paused',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'transfer',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'unpause',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=Erc20PresetMinterPauserFactory.js.map